import { Grid, Paper } from "@material-ui/core";
import { STYLE_MASTER_SATU_BUNDLE, postBundleDetail } from "./helpers";
import {
	InputOptionMaster,
	InputReactDatepicker,
	InputTextMaster,
	LabelRequired,
	Loading,
	MasterButton,
} from "App/Component/ui";
import { useContext, useEffect, useState } from "react";
import BundleKunjunganTable from "./BundleKunjunganTable";
import useReloadTableKunjungan from "./hooks/useReloadTableKunjungan";
import { BundleCtx } from "../context/context";
import { useSelector } from "react-redux";
import {
	defaultToastError,
	defaultToastSuccess,
	isNull,
	today,
} from "App/utils/helpers";
import { v4 as uuidv4 } from "uuid";

function BundleKunjungan({
	handleSelectBundle,
	formDataBundle,
	setFormDataBundle,
	setNewDataDetail,
}) {
	const { state } = useContext(BundleCtx);
	const rows = state.kunjungan.data;
	const totalData = state.kunjungan.count;

	const master = useSelector(({ master }) => master);
	const dokterList = master.dokter.list_select;

	const classes = STYLE_MASTER_SATU_BUNDLE();

	const [loadingKunjungan, setLoadingKunjungan] = useState(false);

	const {
		resetPagination,
		setNewData,
		pagination,
		onPrevious,
		onNext,
		handleClickPageNumber,
		handleChangeLimit,
		loading,
		formFilter,
		handleChange,
		setFormFilter,
	} = useReloadTableKunjungan();

	useEffect(() => {
		setNewData(1, 10, {
			id_kunjungan: formFilter.id_kunjungan,
			id_dokter: formFilter.id_dokter,
			no_rm: formFilter.no_rm,
			nama_pasien: formFilter.nama_pasien,
			tglAwal: today(true),
			tglAkhir: today(true),
		});
	}, []);

	const handleSelect = async (rows) => {
		if (isNull(formDataBundle.id_bundle)) {
			defaultToastError("Bundle Belum Dipilih");
		} else {
			const url_kunjungan = uuidv4();
			const url_askep = uuidv4();
			const url_asmed = uuidv4();

			const response = await postBundleDetail(
				formDataBundle.id_bundle,
				rows.id_kunjungan,
				rows.nama_pasien,
				rows.no_rm,
				rows.id_ihs,
				rows.instalasi,
				rows.nama_dokter,
				rows.participant,
				rows.dokter,
				rows.periode_mulai,
				rows.periode_selesai,
				rows.id_location,
				rows.location,
				rows.asmed.asesmen,
				url_kunjungan,
				url_askep,
				url_asmed,
				rows.status_history_arrive,
				rows.status_history_inprogress,
				rows.status_history_finish
			);

			if (!response.state) {
				setLoadingKunjungan(false);
				defaultToastSuccess(response.message);
				setNewDataDetail(1, 10, {
					id_bundle: formDataBundle.id_bundle,
					tglAwal: "",
					tglAkhir: "",
				});
			} else {
				setLoadingKunjungan(false);
				defaultToastError(response.message);
			}
		}
	};

	const handleSelectKunjungan = () => {
		setNewData(1, 10, {
			id_kunjungan: formFilter.id_kunjungan,
			id_dokter: formFilter.id_dokter,
			no_rm: formFilter.no_rm,
			nama_pasien: formFilter.nama_pasien,
			tglAwal: formFilter.tglAwal,
			tglAkhir: formFilter.tglAkhir,
		});
	};

	return (
		<>
			<Loading show={loadingKunjungan} />

			<div className="mb-2">
				<Paper className={classes.paper}>
					<Grid
						container
						direction="row"
						spacing={1}
						alignItems="center"
						justifyContent="space-between"
					>
						<Grid item md={6}>
							<h4>{`${
								formDataBundle.id_bundle === ""
									? "Semua Kunjungan"
									: `Semua Kunjungan - ID ${formDataBundle.id_bundle} Bundle`
							}`}</h4>
						</Grid>
						<Grid item md={6}>
							<div
								style={{
									display: "flex",
									alignItems: "flex-end",
									justifyContent: "flex-end",
								}}
							>
								<MasterButton
									type="submit"
									size="md"
									color={"lightgreen"}
									name={"Cari Bundle"}
									onClick={() => handleSelectBundle()}
								/>
							</div>
						</Grid>
					</Grid>

					<div className="mb-1">
						<Grid container direction="row" spacing={1}>
							<Grid item md={3}>
								<InputTextMaster
									name="id_bundle"
									label={<LabelRequired label="ID BUNDLE" />}
									id="id_bundle"
									disabled
									placeholder="ID BUNDLE"
									value={formDataBundle.id_bundle}
								/>
							</Grid>
							<Grid item md={3}>
								<InputReactDatepicker
									selected={formFilter.tglAwal}
									label="TANGGAL MULAI"
									handleChangeToday={(e) =>
										setFormFilter({
											...formFilter,
											tglAwal: e,
										})
									}
									onChange={(e) =>
										setFormFilter({
											...formFilter,
											tglAwal: e,
										})
									}
								/>
							</Grid>
							<Grid item md={3}>
								<InputReactDatepicker
									selected={formFilter.tglAkhir}
									label="TANGGAL SELESAI"
									handleChangeToday={(e) =>
										setFormFilter({
											...formFilter,
											tglAkhir: e,
										})
									}
									onChange={(e) =>
										setFormFilter({
											...formFilter,
											tglAkhir: e,
										})
									}
								/>
							</Grid>
							<Grid item md={3}>
								<InputTextMaster
									name="id_kunjungan"
									label={<LabelRequired label="ID KUNJUNGAN" />}
									id="id_kunjungan"
									placeholder="ID KUNJUNGAN"
									value={formFilter.id_kunjungan}
									onChange={handleChange("id_kunjungan")}
								/>
							</Grid>
							<Grid item md={3}>
								<InputTextMaster
									name="no_rm"
									label={<LabelRequired label="NO. RM" />}
									id="no_rm"
									placeholder="NO. RM"
									value={formFilter.no_rm}
									onChange={handleChange("no_rm")}
								/>
							</Grid>
							<Grid item md={3}>
								<InputTextMaster
									name="nama_pasien"
									label={<LabelRequired label="NAMA PASIEN" />}
									id="nama_pasien"
									placeholder="NAMA PASIEN"
									value={formFilter.nama_pasien}
									onChange={handleChange("nama_pasien")}
								/>
							</Grid>
							<Grid item md={3}>
								<InputOptionMaster
									name="dokter"
									label="DOKTER"
									id="dokter"
									data={dokterList}
									withSearch={true}
									value={formFilter.id_dokter}
									labelValue={formFilter.nama_dokter}
									onChange={(e) => {
										if (isNull(e)) {
											setFormFilter({
												...formFilter,
												id_dokter: null,
												nama_dokter: "Pilih Dokter",
											});
										} else {
											setFormFilter({
												...formFilter,
												id_dokter: e?.value,
												nama_dokter: e?.label,
											});
										}
									}}
								/>
							</Grid>
						</Grid>
						<Grid
							container
							spacing={1}
							alignItems="flex-end"
							justifyContent="flex-end"
						>
							<div
								style={{
									display: "flex",
									alignItems: "flex-end",
									justifyContent: "flex-end",
									marginTop: "14px",
								}}
							>
								<MasterButton
									type="submit"
									size="md"
									color={"lightgreen"}
									name={"Cari"}
									onClick={() => handleSelectKunjungan()}
								/>
							</div>
						</Grid>
					</div>

					<BundleKunjunganTable
						rows={rows}
						handleSelect={handleSelect}
						totalData={totalData}
						resetPagination={resetPagination}
						setNewData={setNewData}
						pagination={pagination}
						onPrevious={onPrevious}
						onNext={onNext}
						handleClickPageNumber={handleClickPageNumber}
						handleChangeLimit={handleChangeLimit}
						loading={loading}
						handleChange={handleChange}
						formFilter={formFilter}
						setFormFilter={setFormFilter}
					/>
				</Paper>
			</div>
		</>
	);
}

export default BundleKunjungan;
